import { getStoreMenus, getMenuDoc } from "../../../api/services/storeService";
import { isMenuAvailable } from "../../../api/helpers/datetimeHelper.js";
import { logger } from "./../../../api/Logger.js";
export default {
  state: {
    menuDoc: null,
    timerMenu: null,
    currentStoreIdMenu: null
  },
  mutations: {
    setCurrentStoreMenu(state, payload) {
      if (JSON.stringify(state.menuDoc) != JSON.stringify(payload)) {
        state.menuDoc = payload;
      }
    },
    setMenuTimeSettings(state, payload) {
      state.menuTimeSettings = payload;
    },
    setTimerMenu(state, payload) {
      state.timerMenu = payload;
    },
    setCurrentStoreIdMenu(state, payload) {
      state.currentStoreIdMenu = payload;
    }
  },
  actions: {
    async getStoreMenu(context, payload) {
      if (context.state.timerMenu) window.clearTimeout(context.state.timerMenu);
      if (context.state.currentStoreIdMenu != payload)
        context.commit("setCurrentStoreMenu", {});
      context.commit("setCurrentStoreIdMenu", payload);
      getStoreMenus(payload).onSnapshot(
        async function(snapshot) {
          let storeMenus = [];
          snapshot.docs.forEach(function(doc) {
            if (doc.exists) storeMenus.push({ id: doc.id, ...doc.data() });
          });
          if (storeMenus.length == 1) {
            context.dispatch("changeMenuState", storeMenus[0]);
          } else {
            getMenuDoc(payload).onSnapshot(
              async function(doc) {
                let menuTimeSettings = doc.data()
                  ? doc.data().MenuTimeSettings
                  : null;
                let storeMenu = storeMenus[0];
                if (menuTimeSettings && menuTimeSettings.length > 0) {
                  let menuTS = menuTimeSettings.find(x =>
                    isMenuAvailable(context.getters.currentStoreDoc, x)
                  );
                  if (!menuTS) menuTS = storeMenus[0];
                  storeMenu = storeMenus.find(x => x.id == menuTS.MenuType);
                  if (!storeMenu) storeMenu = storeMenus[0];
                }
                context.dispatch("changeMenuState", storeMenu);
                let timer = setTimeout(() => {
                  context.dispatch("getStoreMenu", payload);
                }, 5000 * 60);
                context.commit("setTimerMenu", timer);
              },
              async function(reason) {
                logger.log(
                  reason.name,
                  reason.toString(),
                  "/menu",
                  logger.LogType.Error
                );
              }
            );
          }
        },
        async function(reason) {
          logger.log(
            reason.name,
            reason.toString(),
            "/menu",
            logger.LogType.Error
          );
        }
      );
    },
    changeMenuState(context, payload) {
      if (context.getters.cartItems && context.getters.cartItems.length > 0) {
        if (!context.state.menuDoc)
          context.commit("setCurrentStoreMenu", payload);
      } else context.commit("setCurrentStoreMenu", payload);
    }
  },
  getters: {
    storeMenu(state) {
      return state.menuDoc;
    }
  }
};
